var _circle, _circle2, _path, _ellipse, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_231_23110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 198",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_231_23110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 788"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "unsplash:aaSTS9p4ayA",
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "#CCCCCC",
    stroke: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 786"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.9993 28.6793C29.7551 28.6793 33.6104 24.8239 33.6104 20.0681C33.6104 15.3124 29.7551 11.457 24.9993 11.457C20.2435 11.457 16.3882 15.3124 16.3882 20.0681C16.3882 24.8239 20.2435 28.6793 24.9993 28.6793Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_231_23110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "unsplash:aaSTS9p4ayA_2",
    cx: 25.0031,
    cy: 24.9987,
    rx: 24.1667,
    ry: 24.1667,
    fill: "#E0E0E0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_231_23110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5015 50.8307V45.2752C42.5015 42.3283 41.5796 39.5022 39.9386 37.4184C38.2977 35.3347 36.0721 34.1641 33.7515 34.1641H16.2515C13.9308 34.1641 11.7052 35.3347 10.0643 37.4184C8.42334 39.5022 7.50146 42.3283 7.50146 45.2752V50.8307",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5015 50.8307V45.2752C42.5015 42.3283 41.5796 39.5022 39.9386 37.4184C38.2977 35.3347 36.0721 34.1641 33.7515 34.1641H16.2515C13.9308 34.1641 11.7052 35.3347 10.0643 37.4184C8.42334 39.5022 7.50146 42.3283 7.50146 45.2752V50.8307H42.5015Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/default-user.b82aeaec0aabd1dab7470df76555d8bb.svg";
export { ForwardRef as ReactComponent };